import React from 'react'
// import PropTypes from 'prop-types'

const UpArrow = () => {
  return (
    <svg width="30px" height="30px" viewBox="0 0 22 12" version="1.1">
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="address_add_details"
          transform="translate(-19.000000, -421.000000)"
          stroke="#414141"
          strokeWidth="2"
        >
          <g id="Group-2" transform="translate(0.000000, 398.000000)">
            <g id="Group-5">
              <g id="Group-4">
                <g id="Group" transform="translate(24.000000, 25.000000)">
                  <polyline
                    id="Line-2"
                    transform="translate(5.479560, 3.284822) rotate(-270.000000) translate(-5.479560, -3.284822) "
                    points="7.95911955 -2 3 3.11836423 7.95911955 8.56964492"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

// CloseButton.defaultProps = {
//   color: '#FFFFFF',
//   size: '15px',
//   onClick: () => {}
// }

// CloseButton.propTypes = {
//   color: PropTypes.string,
//   size: PropTypes.string,
//   onClick: PropTypes.func
// }

export default UpArrow
